<ng-container rtBlock="sc-blog-quote-block">
    <blockquote rtElem="quote">
        <div rtElem="text" [innerHTML]="quote().text"></div>
        @if (quote().title; as cite) {
            <footer rtElem="cite">{{ cite }}</footer>
        }
    </blockquote>
</ng-container>
